<template>
  <div class="do-rollback">
    <!-- Service Options -->
    <div class="do-rollback__service">
      <span> Service: </span>

      <el-select
        class="do-rollback__service-options"
        v-model="selectedService"
        placeholder="Select service"
        :disabled="loading.repoActivities"
      >
        <el-option
          v-for="service in serviceOptions"
          :key="service.name"
          :label="service.name"
          :value="service.name"
        />
      </el-select>
    </div>

    <!-- Rollback Confirmation Dialog -->
    <el-dialog
      title="Are you sure you want to rollback to this commit?"
      :visible.sync="showConfirmDialog"
      :before-close="closeRollbackDialog"
      :append-to-body="true"
    >
      <el-button type="primary" @click="rollback">Rollback</el-button>
      <el-button @click="closeRollbackDialog">Cancel</el-button>
    </el-dialog>

    <!-- Service Activities Table -->
    <Table
      :items="repoActivities"
      :columns="tableColumns"
      :actions="tableActions"
      :loading="loading.repoActivities"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { serviceOptions, devOpsServiceColumns } from "./constants";

import Table from "@/components/Table";

export default {
  name: "Devops",

  components: { Table },

  data() {
    return {
      selectedService: serviceOptions[0].name,
      serviceOptions,

      tableColumns: devOpsServiceColumns,
      tableActions: [
        {
          name: "Rollback to here",
          type: "primary",
          onClick: (repoActivity) => {
            this.openRollbackDialog(repoActivity);
          },
        },
        {
          name: "View on GitHub",
          type: "info",
          onClick: (item) => window.open(item.url, "_blank"),
        },
      ],

      showConfirmDialog: false,

      activityToRollback: {
        author: "",
        date: "",
        is_live: false,
        message: "",
        tag: "",
        url: "",
      },
    };
  },

  computed: {
    ...mapGetters(["loading", "repoActivities", "rollbackRequest"]),
  },

  methods: {
    ...mapActions(["getRepoActivities", "rollbackActivity"]),

    openRollbackDialog(repoActivity) {
      this.showConfirmDialog = true;
      this.activityToRollback = repoActivity;
    },

    closeRollbackDialog() {
      this.showConfirmDialog = false;
    },

    async rollback() {
      this.closeRollbackDialog();
      const { activityToRollback, selectedService } = this;

      await this.rollbackActivity({
        repo: selectedService,
        tag: activityToRollback.tag,
      });

      if (this.rollbackRequest.code == 200) {
        this.$message.success("Rollback done successfully");
        this.getRepoActivities(selectedService);
        return;
      }

      this.$notify.error({
        title: "Error",
        message: "Failed to rollback",
      });
    },
  },

  watch: {
    selectedService: {
      immediate: true,
      handler: function (selectedService) {
        this.getRepoActivities(selectedService);
      },
    },
  },
};
</script>

<style scoped>
.do-rollback {
  margin: 50px 15px;
  width: 100%;
  height: 100%;
}

.do-rollback__service {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.do-rollback__service-options {
  margin-left: 15px;
  width: fit-content;
}
</style>